








import { ciCall } from '~/icons/source/solid/call.ts'
import { ciMail } from '~/icons/source/solid/mail'
import { defineComponent } from '~/utils/nuxt3-migration'
import { ciPrinter } from '~/icons/source/solid/printer'
import { ciExternalLink } from '~/icons/source/regular/external-link'

export default defineComponent({
  props: {
    icon: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      icons: {
        phone: ciCall,
        mobile: ciCall,
        fax: ciPrinter,
        mail: ciMail,
        site: ciExternalLink
      }
    }
  }
})
